var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ReportNav", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "auto-test-container",
      },
      [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "top-title" }, [_vm._v("功能开关")]),
          _c(
            "div",
            { staticClass: "tree-main" },
            [
              _c("el-tree", {
                ref: "tree",
                attrs: {
                  data: _vm.pageConfig.testData,
                  "show-checkbox": "",
                  "default-expand-all": "",
                  "check-strictly": true,
                  "node-key": "id",
                  "highlight-current": "",
                  props: _vm.defaultProps,
                },
                on: { "check-change": _vm.checkChange },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c("line-chart", {
              ref: "chart",
              staticClass: "line-chart",
              attrs: { id: _vm.chartData.id, "chart-data": _vm.chartData.data },
            }),
            _c("div", { staticClass: "top-title" }, [_vm._v("性能指标")]),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", { attrs: { prop: "title", label: "" } }),
                _c("el-table-column", {
                  attrs: { prop: "start", label: "起始帧" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "end", label: "结束帧" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "total", label: "总体帧数" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "avg", label: "平均值" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "min", label: "最小值" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "max", label: "最大值" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }